angular.module('TetherApp').controller('SweepstakesPrizingController', [
    '$mdDialog',
    'sweepstakesService',
    function (
        $mdDialog,
        sweepstakesService
    ) {
        let self = this;

        // General
        self.setTab = function (status) {
            switch (status) {
                case 'draw':
                    self.tab = 0;
                    break;
                case 'review':
                    self.tab = 1;
                    break;
                case 'validation':
                    self.tab = 2;
                    break;
                case 'confirmation':
                    self.tab = 3;
                    break;
                default:
                    self.tab = 0;
            }
        };

        // Tab 1

        // Form setup
        self.hours = range(0, 23);
        self.minutes = range(0, 59);
        self.seconds = range(0, 59);

        // Form values
        self.errors = {};
        self.count = 1;
        self.pool;
        self.type;
        self.hasDates = false;
        self.hasFilters = false;
        self.filters = [];
        self.filter_key;
        self.filter_value;
        self.from_hours = 0;
        self.from_minutes = 0;
        self.from_seconds = 0;
        self.to_hours = 0;
        self.to_minutes = 0;
        self.to_seconds = 0;

        // Tab 2

        self.all = false;
        self.potentials = [];
        self.redraws = [];
        self.keptPotentials = [];
        self.excludePersonIds = [];

        self.updateTypes = function (event) {
            self.types = [];
            let TypeFoundException = {};

            // Cheap hack to stop looping when prize pool is found to set
            // prize types. Using this as Array.prototype.find() is not
            // implemented for Internet Explorer
            try {
                self.pools.forEach(function (pool) {
                    if (pool.id === self.pool) {
                        self.types = pool.prize_types;
                        throw TypeFoundException;
                    }
                });
            } catch (exception) {
                if (exception !== TypeFoundException) {
                    throw exception;
                }
            }
        };

        self.setFromDate = function (datetimeString) {
            let tempFrom = new Date(datetimeString);

            // Convert UTC to local time
            tempFrom.setMinutes(tempFrom.getMinutes() + tempFrom.getTimezoneOffset());

            self.from = tempFrom;
            self.from_hours = tempFrom.getHours();
            self.from_minutes = tempFrom.getMinutes();
            self.from_seconds = tempFrom.getSeconds();
        };

        self.setToDate = function (datetimeString) {
            let tempTo = new Date(datetimeString);

            // Convert UTC to local time
            tempTo.setMinutes(tempTo.getMinutes() + tempTo.getTimezoneOffset());

            self.to = tempTo;
            self.to_hours = tempTo.getHours();
            self.to_minutes = tempTo.getMinutes();
            self.to_seconds = tempTo.getSeconds();
        };

        self.addFilter = function () {
            if (self.filter_key && self.filter_value) {
                delete self.errors.filter_key;
                delete self.errors.filter_value;

                self.filters.push({
                    key: self.filter_key,
                    value: self.filter_value
                });

                // Reset fields
                self.filter_key = '';
                self.filter_value = '';
            } else {
                self.errors = {
                    filter_key: ['The filter key is required'],
                    filter_value: ['The filter value is required']
                };
            }
        };

        self.removeFilter = function (index) {
            self.filters.splice(index, 1);
        };

        self.draw = function () {
            self.errors = {};

            self.drawStatus = 'in_progress';

            sweepstakesService.draw(self.client.eid, self.experience.eid, self.drawEid)
                .then(onDraw, onError);
        };

        let onDraw = function (data) {
            // Add kept and add new potentials
            self.potentials = self.keptPotentials.concat(data.ballots);
            console.log(self.potentials);
            self.drawCount = data.draw_count;
            self.possibleCount = data.possible_count;

            // Reset
            self.redraws = [];
            self.keptPotentials = [];
            self.checkAll();

            self.excludePersonIds = [];

            self.potentials.forEach(function (potential) {
                self.excludePersonIds.push(potential.tether_participant_id);
            });

            if (self.potentials.length === 0) {
                window.alert('No potential winners found');
            }
        };

        self.ballotDraws = function () {
            self.errors = {};

            sweepstakesService.ballotDraws(self.client.eid, self.experience.eid, self.drawEid)
                .then(onBallotDraws, onError);
        };

        let onBallotDraws = function (data) {
            // Add kept and add new potentials
            self.potentials = self.keptPotentials.concat(data.ballots);
            self.drawCount = data.draw_count;
            self.possibleCount = data.possible_count;
        };
        
        let onError = function (response) {
            self.errors = response.data;
        };

        // Tab 2: Review

        self.redraw = function () {
            self.draw(self.redraws);
        };

        self.confirm = function () {
            self.drawStatus = 'complete';

            sweepstakesService.confirm(self.client.eid, self.experience.eid, {
                draw_eid: self.drawEid
            }).then(function (data) {
                window.location.href = route('client-prefix.experience.index', {
                    type: 'sweepstakes',
                    client: self.client_eid
                });
            }, function (xhr) {
                window.alert('An error occurred, please contact support.');
            });
        };

        self.isValidationChecked = function () {
            if (! self.hasValidation) {
                return self.redraws.length !== 0;
            } else {
                let isChecked = false;
                let checked = [];

                self.potentials.forEach(function (potential) {
                    if (['valid', 'invalid'].indexOf(potential.entry.status) > -1) {
                        checked.push(potential);
                    }
                });

                if (checked.length === self.potentials.length) {
                    isChecked = true;
                }

                return (self.redraws.length !== 0 || ! isChecked);
            }
        };

        self.checkAll = function () {
            if (self.redraws.length === self.potentials.length) {
                self.all = true;
            } else {
                self.all = false;
            }
        };

        self.toggleAll = function () {
            self.potentials.forEach(function (potential) {
                let index = self.redraws.indexOf(potential.id);
                if (! self.all) {
                    self.redraws.splice(index, 1);
                } else {
                    self.redraws.push(potential.id);
                }
            });
        };

        self.exists = function (item) {
            return self.redraws.indexOf(item) > -1;
        };

        self.toggle = function (item) {
            let index = self.redraws.indexOf(item);
            if (index > -1) {
                self.redraws.splice(index, 1);
            } else {
                self.redraws.push(item);
            }
            self.checkAll();
        };

        self.check = function (item) {
            let index = self.redraws.indexOf(item);
            if (index === -1) {
                self.redraws.push(item);
            }
            self.checkAll();
        };

        self.uncheck = function (item) {
            let index = self.redraws.indexOf(item);
            if (index > -1) {
                self.redraws.splice(index, 1);
            }
            self.checkAll();
        };

        self.dataGet = function (key, data) {
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }

            return data.hasOwnProperty(key) ? data[key] : '';
        };

        let validationModalController = function ($mdDialog) {
            var validationCtrl = this;
            validationCtrl.isDataOpen = false;
            validationCtrl.isOtherDataOpen = false;
            validationCtrl.parentController = self;
            validationCtrl.ballot = self.validationModalBallot;
            validationCtrl.data = self.validationModalBallot.data;
            validationCtrl.images = self.validationModalBallot.entries[0].images;
            validationCtrl.otherEntries = [];
            validationCtrl.otherIndex = 0;
            validationCtrl.isAll = false;
            self.setTab('current');

            validationCtrl.toggleData = function () {
                validationCtrl.isDataOpen = !validationCtrl.isDataOpen;
            };

            validationCtrl.toggleOtherData = function () {
                validationCtrl.isOtherDataOpen = ! validationCtrl.isOtherDataOpen;
            };

            sweepstakesService.other(
                self.client.eid,
                self.experience.eid,
                validationCtrl.ballot.entries[0].eid
            ).then(function (data) {
                validationCtrl.otherEntries = data.map(function (other) {
                    if (other.hasOwnProperty('entry') && other.entry.hasOwnProperty('data') && typeof other.entry.data === 'string') {
                        other.entry.data = JSON.parse(other.entry.data);
                    }
                    return other;
                });
            }, onError);

            validationCtrl.previousOther = function () {
                if (validationCtrl.otherIndex > 0) {
                    validationCtrl.otherIndex--;
                }
            };

            validationCtrl.nextOther = function () {
                if (validationCtrl.otherIndex < validationCtrl.otherEntries.length - 1) {
                    validationCtrl.otherIndex++;
                }
            };

            validationCtrl.valid = function () {

                sweepstakesService.ballotDrawPotentialWinner(
                    validationCtrl.parentController.client.eid,
                    validationCtrl.parentController.experience.eid,
                    validationCtrl.ballot.ballot_draw_eid,
                    validationCtrl.isAll
                ).then(function () {
                    // Do nothing
                    validationCtrl.ballot.validated_at = 'now';
                }, onError);
                validationCtrl.cancel();
            };

            validationCtrl.invalid = function () {
                sweepstakesService.ballotDrawInvalid(
                    validationCtrl.parentController.client.eid,
                    validationCtrl.parentController.experience.eid,
                    validationCtrl.ballot.ballot_draw_eid,
                    validationCtrl.isAll
                ).then(function (data) {
                    // Add kept and add new potentials

                    if(data.ballots.hasOwnProperty(0)) {
                        self.potentials.push(data.ballots[0]);
                        self.drawCount = data.draw_count;
                        self.possibleCount = data.possible_count;
                    }
                    // Set tab in view
                    self.setTab('review');

                    validationCtrl.ballot.invalidated_at = 'now';
                }, onError);
                validationCtrl.cancel();
            };

            /*validationCtrl.kicked = function () {
                validationCtrl.entry.status = 'kicked';
                validationCtrl.parentController.check(validationCtrl.entry.id);
                sweepstakesService.kicked(
                    validationCtrl.parentController.experience.eid,
                    { entries: [validationCtrl.entry] }
                ).then(function (data) {
                    // Do nothing
                }, onError);
                validationCtrl.cancel();
            };*/

            validationCtrl.isImage = function (search) {
                let imageTypes = ['JPG', 'jpg', 'JPEG', 'jpeg', 'GIF', 'gif', 'PNG', 'png'];

                for (let i = imageTypes.length - 1; i >= 0; i--) {
                    let lookfor = '.' + imageTypes[i];
                    let lastIndex = search.lastIndexOf(lookfor);
                    let calculatedLength = lastIndex + lookfor.length;
                    if (lastIndex !== -1
                        && search.length === calculatedLength) {
                        return true;
                    }
                }

                return false;
            };

            // Setup, self-invoked
            (function () {

                    //for (let key in validationCtrl.data) {
                    //    if (typeof validationCtrl.data[key] === 'string'
                    //        && validationCtrl.isImage(validationCtrl.data[key])) {
                    //        validationCtrl.images.push(validationCtrl.data[key]);
                    //    }
                    //}

            })();

            // Modal specific
            validationCtrl.hide = function () {
                $mdDialog.hide();
            };

            validationCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };

        self.validationModal = function (event, ballot) {
            if (ballot.hasOwnProperty('data') && typeof ballot.data === 'string') {
                ballot.data = JSON.parse(ballot.data);
            }
            self.validationModalBallot = ballot;
            validationModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: validationModalController,
                controllerAs: 'validationCtrl',
                bindToController: true,
                templateUrl: '/experience/sweepstakes/prizing/validation',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let dataModalController = function ($mdDialog) {
            let dataCtrl = this;
            dataCtrl.data = self.dataModalData;

            dataCtrl.hide = function () {
                $mdDialog.hide();
            };

            dataCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };

        self.dataModal = function (event, data) {
            if (typeof data === 'string') {
                data = JSON.parse(data);
            }
            self.dataModalData = data;
            dataModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: dataModalController,
                controllerAs: 'dataCtrl',
                bindToController: true,
                templateUrl: '/experience/sweepstakes/prizing/data',
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

    }
]);
